import { memo, useEffect, useState } from "react";
import tw from "twin.macro";
import TopbarMenus from "./TopbarMenus";
import { ECommerce } from "api/AppConfigApi";
import { getBranchId, setBranchId } from "../../utility/HeaderConfig.js";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import "styles/themeStyles.css";
import findStore from "../../shopyellow.jpg";
// import { useCartContext } from "context/UseCartContext";
import { reactLocalStorage } from "reactjs-localstorage";
import logo1 from "../../images/assets/logo1.svg"

// import logo38 from "../../images/assets/logo38.png"
import logo38 from "../../contactblack.jpg"
import logo39 from "../../images/assets/logo39.png"
import { useCartContext } from "context/UseCartContext";
import CallSupport from "./CallSupport";
import moment from "moment";
import { filterFormatFromDate, filterFormatToDate } from "utility/Constant";
import { PurityApi } from "api/PurityApi";


const TopbarContainer = tw.div`text-black `;

function Topbar({ branch }) {
  const [animationPhase, setAnimationPhase] = useState("animate");
  const [silverrate, setRecentSilverRate] = useState({
      metaProdTypeName: "Silver",
      rate: "N/A",
      unitType: "",
    });

  // const [media, setMedia] = useState([]);
  const [branches, setBranches] = useState([]);

  const { dispatch } = useCartContext();

  let history = useNavigate();

  const text = "Jai Maruthi JEWELLERY";

  const containerVariants = {
    animate: {
      transition: {
        staggerChildren: 0.06,
        repeat: Infinity,
        repeatDelay: 1.2, // Delay between full loops
      },
    },
  };

  const letterVariants = {
    animate: {
      y: [-2, -8, 0],
      transition: {
        duration: 0.6,
        ease: "easeInOut",
      },
    },
  };

   const getProductRate = async () => {
      let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
      const filterData = {
        branch: getBranchId(),
        createdAtFrom: filterFormatFromDate(fromDate),
        createdAtTo: filterFormatToDate(toDate),
      };
      const todayMetalRate = await PurityApi(filterData);
      if (todayMetalRate.errorCode === undefined) {
        let isSilverRateFound = false;
        todayMetalRate.response.forEach((item) => {
          if (
            item.metaProdTypeName &&
            item.metaProdTypeName.toLowerCase() === "silver" &&
            !isSilverRateFound
          ) {
            setRecentSilverRate(item);
            isSilverRateFound = true;
          }
        });
      }
    };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationPhase("loop");
    }, text.length * 100 + 1000);
    getProductRate();
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    getAllBrachDetails();
    // socialMedia();
    reactLocalStorage.setObject('branchName', branch.branchName)
    // eslint-disable-next-line
  }, []);

  const getAllBrachDetails = () => {
    const moduleName = "endpoint";
    ECommerce(moduleName).then((data) => {
      const branchResponse = JSON.parse(data.response.moduleField);
      setBranches(branchResponse);
    });
  };

  // const socialMedia = () => {
  //   let filter = "social_media_config";
  //   ECommerce(filter).then((data) => {
  //     let SOCIALMEDIA = JSON.parse(data.response.moduleField);
  //     setMedia(SOCIALMEDIA);
  //   });
  // };

  const selectBranch = (branchId) => {
    setBranchId(branchId);
    dispatch({ type: "BRANCHID", payload: branchId });
    history("/");
    reactLocalStorage.setObject('branchName', branch.branchName)

  };

  // const messages = [
  //   // <>Gifts for the Queens of your heart - <button>Shop Now!</button></>,
  //   <><button>Flat 30%</button> on Solitaire prices</>,
  //   <>Pay Day Treats just for You <button>Pamper now</button></>
  // ];

  const [index, setIndex] = useState(0);


  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIndex((prevIndex) => (prevIndex + 1) % messages.length);
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, []);


  return (
    // <TopbarContainer style={{ background: ' #f0b917' }}>
    //   <div tw="max-w-full px-4 sm:px-6 lg:px-8 m-auto flex items-center justify-center sm:justify-between h-6">
    //     <div tw="xl:flex-1 lg:flex-grow-0 lg:inline-flex hidden items-center text-white gap-5 relative">
    //       {/* <i className="bi bi-shop" tw="text-xl font-semibold"></i>
    //        <span className="hover-trigger ms-2 relative" tw="text-xs sm:text-sm lg:text-xs xl:text-sm cursor-pointer">
    //         <div className="d-flex gap-2 align-items-center">
    //           <small> Branch : {branch.branchName} </small>
    //           <i className="bi bi-caret-down" tw="text-base mx-1"></i>
    //         </div>
    //         <div
    //           className="hover-target"
    //           tw="absolute left-0 text-left bg-white w-40 py-2 rounded-md shadow-xl">
    //           {branches.map(
    //             (data) =>
    //               branch.branchName !== data.name && (
    //                 <span
    //                   tw="no-underline text-black hover:bg-[#faeae2] p-2 hover:text-black block  hover:(-translate-y-2 bg-custom-200) duration-300 transition ease-in-out delay-150 hover:shadow-lg"
    //                   onClick={() => selectBranch(data.id)}
    //                 >
    //                   <i
    //                     className="bi bi-arrow-return-right"
    //                     tw=" px-3 text-base"
    //                   ></i>
    //                   {data.name}
    //                 </span>
    //               )
    //           )}
    //         </div>
    //       </span> */}
    //       <span tw="lg:text-xs xl:text-sm text-black font-normal ml-1" className="d-flex">
    //         Need Help? call us: {branch.mobile}
    //         <CallSupport mobile={branch.mobile} />
    //       </span>
    //       {/* <motion.h6
    //         className="ms-auto mt-1 d-flex"
    //         style={{
    //           fontSize: "14px",
    //           fontWeight: "bold",
    //           letterSpacing: "2px",
    //           marginLeft: "20px",
    //           color: "black",
    //           overflow: "hidden",
    //           whiteSpace: "nowrap",
    //         }}
    //         variants={containerVariants}
    //         initial="animate"
    //         animate="animate"
    //       >
    //         {text.split("").map((char, index) => (
    //           <motion.span
    //             key={index}
    //             variants={letterVariants}
    //             style={{
    //               display: "inline-block",
    //             }}
    //           >
    //             {char === " " ? "\u00A0" : char}
    //           </motion.span>
    //         ))}
    //       </motion.h6> */}
    //       <h6 className="text-dark mt-1"
    //        style={{
    //           fontSize: "14px",
    //           fontWeight: "bold",
    //           letterSpacing: "2px",
    //           marginLeft: "20px",
    //           color: "black",
    //           overflow: "hidden",
    //           whiteSpace: "nowrap",
    //           marginLeft: '341px'
    //         }}>
    //           Jai Maruthi Jewellery
    //           </h6>
    //       {/* <div className="d-flex gap-2 align-items-center ms-auto">
    //     <div className="d-flex align-items-center gap-2">
    //            <i className="bi bi-server text-secondary" style={{ fontSize: "16px" }}></i>
    //            <span className="text-dark fw-medium">{silverrate.metaProdTypeName}</span>
    //            <span className="text-dark fw-medium" >
    //              {silverrate?.onlineRate > 0
    //                ? `₹ ${silverrate.onlineRate}`
    //                : silverrate?.rate !== "N/A"
    //                  ? `₹ ${silverrate.rate}`
    //                  : ""}
    //            </span>
    //            <span className="text-dark fw-medium">{silverrate.unitType ? `/${silverrate.unitType}` : ""}</span>
    //          </div>
    //      <Link
    //         to="/find-store-page"
    //         className="d-flex align-items-center text-dark text-decoration-none"
    //         style={{ gap: "8px" }}
    //       >
    //         <img src={findStore} alt="Find Store" style={{ width: 17 }} />
    //         <span className="fw-medium" style={{ fontSize: "14px", whiteSpace: "nowrap" }}>FIND STORE</span>
    //       </Link> 
    //         <h6>
    //           <img className="mt-2" style={{ width: 17 }} src={logo38}></img>
    //         </h6>
    //         <a href="/Contact" style={{ color: "black", textDecoration: "none" }}>
    //           <small className="mt-1">CONTACT US</small>
    //         </a>
    //       </div> */}
    //     </div>


    //     {/* <div className="d-flex flex-grow-1 justify-content-center">
    //             <p key={index} className="fade-in">{messages[index]}</p>
    //           </div> */}


    //     {/* Branch : {branch.branchName} */}

    //     {/* <i className="bi bi-caret-down" tw="text-base mx-1"></i> */}
    //     {/* <div
    //           className="hover-target"
    //           tw="absolute right-0 text-left bg-white w-40   py-2 rounded-md shadow-xl"
    //         >
    //           {branches.map(
    //             (data) =>
    //               branch.branchName !== data.name && (
    //                 <span
    //                   tw="no-underline text-black hover:bg-[#faeae2] p-2 hover:text-black block  hover:(-translate-y-2 bg-custom-200) duration-300 transition ease-in-out delay-150 hover:shadow-lg"
    //                   onClick={() => selectBranch(data.id)}
    //                 >
    //                   <i
    //                     className="bi bi-arrow-return-right"
    //                     tw=" px-3 text-base"
    //                   ></i>
    //                   {data.name}
    //                 </span>
    //               )
    //           )}
    //         </div> */}
    //     {/* </span>
    //     </div> */}
    //     {/* <div tw="hidden sm:flex text-center">
    //       {media.map((data, index) => (
    //         <a href={data.value} tw="text-black" target="blank" key={index}>
    //           <i
    //             className={`bi bi-${data.key?.toLowerCase()}`}
    //             tw="text-base mx-2 md:mx-4  hover:text-rose-500 cursor-pointer"
    //           ></i>
    //         </a>
    //       ))}
    //     </div> */}
    //     <TopbarMenus />
    //     {/* Mobile-only message banner */}
    //     {/* <div className="d-flex d-lg-none justify-content-center text-white py-1 px-2 text-center">
    //       <small key={index} className="fade-in">
    //         {messages[index]}
    //       </small>
    //     </div> */}

    //   </div>

''
    //   <div></div>

    // </TopbarContainer>
  );
}

export default memo(Topbar);
